import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>;
    }

    // If admin is authenticated, redirect to admin dashboard
    if (user && user.role === 'admin') {
        return <Navigate to="/admin" />;
    }

    // If regular user is authenticated, redirect to user dashboard
    if (user && user.role === 'user') {
        return <Navigate to="/dashboard" />;
    }

    return <>{children}</>;
};

export default PublicRoute;
